import React from 'react';
import { ChipBase } from '../chip-base/chip-base';
export const ChipSelect = ({ content, ...restProps }) => {
    return (React.createElement(ChipBase, { size: "m", content: [
            {
                text: content,
                style: 'regular',
            },
        ], ...restProps }));
};
//# sourceMappingURL=chip-select.js.map